import React from 'react'
import FactoryKPIS from '../../../KPIS'
import FactoryKPIsChart from '../../../KpiCharts'
import StatusWrapper from '../../../StatusWrapper'
import UbliqueColumn from '../Column'
import UbliqueRow from '../Row'

import './index.scss'

const kpiMap = {
  KPIS: StatusWrapper(FactoryKPIS),
  CHART: StatusWrapper(FactoryKPIsChart)
}
const StripeKPIs = ({ kpis, stripeKpisTitle, stripeKpisComponent }) => {
  const StripeKpisComponent = stripeKpisComponent?.component
  return (
    <>
      <UbliqueRow className='ublique-row-kpis'>
        {(stripeKpisTitle || stripeKpisComponent) && (
          <UbliqueColumn
            className='ublique_column-kpis_header'
            sm={4}
            md={8}
            lg={12}
          >
            <div className='ublique-column-kpis'>
              {stripeKpisTitle && <h4>{stripeKpisTitle}</h4>}
              {stripeKpisComponent && (
                <div className='ublique-column-kpis-component'>
                  <StripeKpisComponent />
                </div>
              )}
            </div>
          </UbliqueColumn>
        )}

        {kpis.map(({ factory, config, factoryConfig }, idx) => {
          const Element = kpiMap[factory]
          return (
            <UbliqueColumn
              key={`page-output-stripe-kpis-${idx}`}
              sm={config.sm}
              md={config.md}
              lg={config.lg}
            >
              <Element {...factoryConfig} />
            </UbliqueColumn>
          )
        })}
      </UbliqueRow>
    </>
  )
}

export default StripeKPIs
